import { createTheme } from '@mui/material/styles';

export const muiTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 639,
      md: 1025,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    text: {
      primary: '#000000',
      secondary: '#000000',
    },
    primary: {
      main: '#1A96F0',
    },
    secondary: {
      main: '#FFFFFF',
    },
    warning: {
      main: '#FABC3F',
    },
    error: {
      main: '#FF0000',
    },
  },
  typography: {
    fontSize: 16,
    fontFamily: 'Meiryo, Hiragino, sans-serif',
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: 16,
          lineHeight: 1.5,
          fontWeight: 400,
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
        }),
        h2: ({ theme }) => ({
          fontSize: 28,
          fontWeight: 'bold',
          [theme.breakpoints.down('lg')]: {
            fontSize: 16,
          },
        }),
        h4: ({ theme }) => ({
          fontSize: 20,
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
        }),
        h5: {
          fontSize: 18,
          fontWeight: 'bold',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: 16,
          lineHeight: 1.5,
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
        }),
        asterisk: {
          color: '#ff0000',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          margin: '4px 0 0 0',
          fontSize: 14,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: 16,
          lineHeight: 1.5,
          backgroundColor: '#FFFFFF',
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
          '&:has(.Mui-disabled)': {
            backgroundColor: '#0000001f',
          },
        }),
        input: ({ theme }) => ({
          height: 'unset',
          padding: '13px 20px !important',
          [theme.breakpoints.down('lg')]: {
            height: 21,
          },
        }),
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: 16,
          lineHeight: 1.5,
          fontWeight: 'bold',
          margin: '0 0 0 16px',
          '&.Mui-selected': {
            color: '#7949FF',
            backgroundColor: '#E9E1FF',
            border: '1px solid #7949FF',
          },
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
        }),
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          height: 80,
          backgroundColor: '#1A96F0',
          '.MuiAvatar-root': {
            height: 50,
            width: 50,
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          '.MuiListItemButton-root': {
            '&.:hover': {
              backgroundColor: '#0B60B04d',
            },

            '&.Mui-selected': {
              backgroundColor: '#0B60B0',
              '&:hover': {
                backgroundColor: '#0b60b0cc',
              },
            },
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: 16,
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: '13px 20px',
          fontSize: 16,
          lineHeight: 1.5,
          fontWeight: 400,
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
        }),
        text: {
          color: '#0B60B0',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: ({ theme }) => ({
          textAlign: 'center',
          fontSize: 28,
          fontWeight: 'bold',
          [theme.breakpoints.down('lg')]: {
            fontSize: 20,
          },
        }),
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          display: 'flex',
          flexDirection: 'column',
          gap: 20,
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: ({ theme }) => ({
          textAlign: 'center',
          fontSize: 20,
          whiteSpace: 'break-spaces',
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
        }),
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: ({ theme }) => ({
          '& .MuiButton-text': {
            fontSize: 20,
            [theme.breakpoints.down('lg')]: {
              fontSize: 16,
            },
          },
        }),
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: 16,
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
        }),
        head: {
          fontWeight: 'bold',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: '#0B60B0',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: 16,
          lineHeight: 1.5,
          [theme.breakpoints.down('lg')]: {
            fontSize: 14,
          },
        }),
      },
    },
  },
});
